// extracted by mini-css-extract-plugin
export default {"modal":"Spinner_modal__JjZWV"};